// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"549":"da5001bc","777":"b46ef4d6"}[chunkId] + ".chunk.css";
};